module.exports = __webpack_public_path__ + "img/emitFacemakeup01.f8aae6c4.png";